import { render, staticRenderFns } from "./SingleWeekday.vue?vue&type=template&id=f5152644"
import script from "./SingleWeekday.vue?vue&type=script&lang=js"
export * from "./SingleWeekday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports